export const PAIRING_CLEAR = 'PAIRING_CLEAR';
export const PAIRING_HIDE_POP_UP = 'PAIRING_HIDE_POP_UP';
export const PAIRING_UPDATE_START = 'PAIRING_UPDATE_START';
export const PAIRING_UPDATE_FINISH = 'PAIRING_UPDATE_FINISH';
export const PAIRING_START = 'PAIRING_START';
export const PAIRING_FINISH = 'PAIRING_FINISH';
export const PAIRING_ENABLE_SUBMIT = 'PAIRING_ENABLE_SUBMIT';
export const PAIRING_TURN_ON_ALL_CAPABILITIES = 'PAIRING_TURN_ON_ALL_CAPABILITIES';
